export const mkbz = {
    GD001:'/personalInformation',
    GD002:'/buy',
    GD003:'/clothingSize',
    GD004:'/report',
    GD005:'/channel',
    GD006:'/chooseDormitory',
    GD007:'/major',
    GD008:'/onlinePayment',
    GD009:'/print',
    GD010:'/sszychannel',
    GD011:'/sszywsjxf',
    GD012:'/sszyssfp',
    GD013:'/ssxzywsjssf',
    GD014:'/schoolUniform',
    GD019:'/photoInformation'
}


// WEBPACK FOOTER //
// ./app/pages/Assembly/siderMenu/menuObj.js